import { Form } from "react-bootstrap";
import EpomReport from './partials/EpomReport';
import { useContext, useEffect, useState } from "react";
import MediaSmartReport from "./partials/MediaSmartReport";
import SmadexReport from "./partials/SmadexReport";
import SmartyAdsReport from "./partials/SmartyAdsReport";
import { fetchData, ORG_ALL } from "../../components/Service";
import { Context } from "../../components/Context";

const Reporting = () => {
    const [dsp, setDsp] = useState("Epom");
    const [context] = useContext(Context)
    const [orgList, setOrgList] = useState([])
    const [orgId, setOrgId] = useState();

    const getOrgList = (e) => {    
                fetchData(ORG_ALL, 'GET', "", true, false, (res) => {
                    if (res.status === "success") {
                        setOrgList(res?.records)
                        setOrgId(res?.records[0]?.id)
                    } else {
                        // displayError(res.errors)
                    }
                });
            }
    
        useEffect(() => {
            getOrgList()
        }, [])

    return (
        <div className="dashboard-content-block">
            <div className="dashbaord-heading">
                DSP Reporting
            </div>
            <div className="select-dsp-block create-user-block sp-reporting-block">
                {context?.role == "admin" && 
                    <Form.Group className="form-group">
                        <Form.Label>Select Organization</Form.Label>
                        <Form.Select onChange={(e) => setOrgId(e.target.value)}>
                            {orgList && orgList.length && orgList.map((item, i) => (
                                <option value={item.id} selected={orgId == item.id}>
                                    {item.name}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                }
                <Form.Group className="form-group">
                    <Form.Label>Select DSP</Form.Label>
                    <Form.Select onChange={(e) => setDsp(e.target.value)}>
                        <option value="Epom" defaultChecked>
                            Epom
                        </option>
                        <option value="Mediasmart">
                            Mediasmart
                        </option>
                        <option value="Smadex">
                            Smadex
                        </option>
                        <option value="SmartyAds">
                            SmartyAds
                        </option>
                    </Form.Select>
                </Form.Group>
            </div>
            <div className="custom-datatable-block">
            {context?.role == "admin" && orgId ? <>
                { dsp === "Epom" && <EpomReport orgId={orgId}/>}
                { dsp === "Mediasmart" && <MediaSmartReport orgId={orgId}/>}
                { dsp === "Smadex" && <SmadexReport orgId={orgId}/>}
                { dsp === "SmartyAds" && <SmartyAdsReport orgId={orgId}/>}
                </> : <>
                { dsp === "Epom" && <EpomReport />}
                { dsp === "Mediasmart" && <MediaSmartReport />}
                { dsp === "Smadex" && <SmadexReport />}
                { dsp === "SmartyAds" && <SmartyAdsReport />}
                </>
            }
            </div>
        </div>
    );
};

export default Reporting;
